import { useFeatureFlags } from '@hooks/useFeatureFlags';
import { isPPLFrontend } from '@utils/app-paths';

export const useSavedViewsEnabled = (): boolean => !!useFeatureFlags()('OpenSearch') && !isPPLFrontend;
